// extracted by extract-css-chunks-webpack-plugin
module.exports = {"entry_gray":"entry_gray_9olNa","entry_wrap":"entry_wrap_JlWKA"};